import { t } from "adapters/i18n";
import type { ServiceConstructor } from "../services.types";

export function WeightServiceMixin<TBase extends ServiceConstructor>(
  Base: TBase
) {
  return class WeightService extends Base {
    readonly weightUrl = `${process.env.REACT_APP_ENDPOINT}herds/weight`;

    async finishWeights(weightIds: number[]): Promise<void> {
      try {
        const url = `${this.weightUrl}/finish-weights`;
        await this.patch(url, { weightIds });
      } catch (_) {
        throw new Error(t("livestock:finish-weights-error"));
      }
    }
  };
}
